import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getOrderDetailProducts2, getOrderStatusList } from '@/services/order/orderDetail';
import { toThousandslsFilter } from "@/filters/";
export default {
  name: 'orderDetailProduct',
  i18n: require('../i18n-orderDetail'),
  props: {
    orderInfo: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    var originalcolumnsAgent = [{
      //传票番号
      title: this.$t('orderDetailProduct.expressNo'),
      dataIndex: 'expressNo',
      key: 'expressNo',
      scopedSlots: {
        customRender: 'expressNo'
      }
    }, {
      //传票金额
      title: this.$t('orderDetailProduct.expressNoAmount'),
      dataIndex: 'erpOrderAmount',
      key: 'erpOrderAmount',
      scopedSlots: {
        customRender: 'expressNoAmount'
      }
    }];
    return {
      orderId: "",
      productInfo: {},
      orderStatusList: [],
      oldProductList: [],
      isTableLoading: false,
      rightCurrencySymbol: localStorage.rightCurrencySymbol,
      leftCurrencySymbol: localStorage.leftCurrencySymbol,
      agentTitle: this.$t('orderDetailProduct.bundleAgent'),
      agentVisible: false,
      agentData: [],
      columnsAgent: [],
      originalcolumnsAgent: originalcolumnsAgent,
      orderStatus: undefined,
      anchorList: ['lengcang', 'changwen', 'lengdong'],
      taxTotal: 0,
      tax10: 0,
      tax8: 0,
      cashOnDeliveryAmountTotal: 0,
      productTotal: 0
    };
  },
  computed: {
    columns: function columns() {
      var columns = [{
        //商品编号
        title: this.$t('orderDetailProduct.productNo'),
        dataIndex: 'productNo',
        key: 'productNo',
        width: 100
      }, {
        //商品名称
        title: this.$t('orderDetailProduct.productName'),
        dataIndex: 'productName',
        key: 'productName',
        scopedSlots: {
          customRender: 'productName'
        }
      },
      // 原价
      // {
      // 	title: this.$t('orderDetailProduct.price'),
      // 	dataIndex: 'price',
      // 	key: 'price',
      // 	width: 120,
      // 	scopedSlots: { customRender: 'price' },
      // 	align: 'right'
      // },

      // 商品规格

      // 售卖方式
      {
        title: this.$t('orderDetailProduct.sellWay'),
        dataIndex: 'sellWay',
        key: 'sellWay',
        width: 120,
        scopedSlots: {
          customRender: 'sellWay'
        },
        align: 'right'
      }, {
        //售价
        title: this.$t('orderDetailProduct.salePrice'),
        dataIndex: 'salePrice',
        key: 'salePrice',
        width: 120,
        scopedSlots: {
          customRender: 'salePrice'
        },
        align: 'right'
      }, {
        //商品数量
        title: this.$t('orderDetailProduct.productNum'),
        dataIndex: 'productNum',
        key: 'productNum',
        scopedSlots: {
          customRender: 'productNum'
        },
        width: 100,
        align: 'right'
      },
      // 消费税
      {
        title: this.$t('orderDetailProduct.Tax'),
        dataIndex: 'taxAmount',
        key: 'taxAmount',
        scopedSlots: {
          customRender: 'taxAmount'
        },
        width: 100,
        align: 'right'
      },
      //获取积分
      // {
      // 	title: this.$t('orderDetailProduct.getPointNum'),
      // 	dataIndex: 'getPointNum',
      // 	key: 'getPointNum',
      // 	width: 100,
      // 	align: 'right'
      // },
      {
        //金额小计
        title: this.$t('orderDetailProduct.productSubTotal'),
        dataIndex: 'productSubTotal',
        key: 'productSubTotal',
        scopedSlots: {
          customRender: 'productSubTotal'
        },
        width: 120,
        align: 'right'
      }];
      return columns;
    }
  },
  mounted: function mounted() {
    //区分运营方式
    this.deliveryChannel = localStorage.getItem('deliveryChannel');
    this.orderId = this.$route.query.id;
    this.loadData();
    // this.loadOrderStatusList()
  },
  methods: {
    formatMoney: function formatMoney(num) {
      return localStorage.leftCurrencySymbol + toThousandslsFilter(num) + localStorage.rightCurrencySymbol;
    },
    loadData: function loadData() {
      var _this = this;
      getOrderDetailProducts2({
        id: this.orderId
      }).then(function (response) {
        if (response.data.code == 200) {
          _this.productInfo = response.data.data;

          // 消费税
          if (_this.productInfo.taxList) {
            _this.productInfo.taxList.forEach(function (item, index) {
              if (item.taxDiff == '10%') {
                _this.tax10 = item.taxAmount;
              }
              if (item.taxDiff == '8%') {
                _this.tax8 = item.taxAmount;
              }
            });
            _this.taxTotal = _this.tax10 + _this.tax8;
          } else {
            _this.tax10 = 0;
            _this.tax8 = 0;
            _this.taxTotal = 0;
          }

          // 代引金额总数
          // this.productInfo.transportList.forEach((item,index,arr) => {
          // 	this.cashOnDeliveryAmountTotal += item.cashOnDeliveryAmount
          // 	arr[index].productTotal = 0
          // 	item.productList.forEach(item2 => {
          // 		arr[index].productTotal += item2.productSubTotal
          // 	})
          // })
          // this.orderStatus = this.productInfo.subOrderVoList[0].orderStatus
          // if(this.productInfo.isOldOrder == 1){
          // 	this.loadOldData();
          // }
        }
      });
    },
    // 		loadOldData(){
    //     this.isTableLoading = true
    // 			let tempProductList = [];
    // 			for(let orderChannelKey in this.productInfo.subOrderVoList){
    // 				let orderChannel = this.productInfo.subOrderVoList[orderChannelKey]
    // 				if(orderChannel && orderChannel.transportList && orderChannel.transportList.length>0){
    // 					for(let temperatureKey in orderChannel.transportList){
    // 						let tempTemperature = orderChannel.transportList[temperatureKey];
    // 						if(tempTemperature && tempTemperature.productList && tempTemperature.productList.length>0){
    //             for ( let productKey in tempTemperature.productList ) {
    //               let tempProduct = tempTemperature.productList[productKey];
    //               if ( tempProduct ) {
    //                 tempProductList.push(tempProduct);
    //               }
    //             }
    //           }
    //         }
    //       }
    //     }
    //     this.oldProductList = tempProductList;
    //     this.isTableLoading = false
    //   },
    loadOrderStatusList: function loadOrderStatusList() {
      var _this2 = this;
      getOrderStatusList(this.orderId).then(function (response) {
        if (response.data.code == 200) {
          _this2.orderStatusList = response.data.data;
        }
      });
    },
    getStatus: function getStatus(Status) {
      return this.$t("public.orderStatus".concat(Status.orderStatus)) + "　" + Status.createTime;
    },
    goAgentAmount: function goAgentAmount(agdata, amount) {
      var columns = _.cloneDeep(this.originalcolumnsAgent);
      if (amount > 0) {
        this.agentTitle = this.$t('orderDetailProduct.bundleAgent') + '(' + agdata.length + '枚)';
      } else {
        this.agentTitle = this.$t('orderDetailProduct.bundleAgent');
        columns.push({
          //代引金额
          title: this.$t('orderDetail2.bundleAgent'),
          dataIndex: 'deliveryAmount',
          key: 'deliveryAmount',
          scopedSlots: {
            customRender: 'deliveryAmount'
          }
        });
      }
      this.columnsAgent = columns;
      this.agentVisible = true;
      this.agentData = agdata;
    }
  }
};